var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8332 4.66602H5.49984C5.14622 4.66602 4.80708 4.80651 4.55703 5.05656C4.30698 5.30661 4.1665 5.64573 4.1665 5.99935V15.3327C4.1665 15.6863 4.30698 16.0254 4.55703 16.2755C4.80708 16.5255 5.14622 16.666 5.49984 16.666H14.8332C15.1868 16.666 15.5259 16.5255 15.776 16.2755C16.026 16.0254 16.1665 15.6863 16.1665 15.3327V5.99935C16.1665 5.64573 16.026 5.30661 15.776 5.05656C15.5259 4.80651 15.1868 4.66602 14.8332 4.66602Z",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 3.33301V5.99967",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.33301V5.99967",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 8.66602H16.1665",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_date.84382d85.svg";
export { ForwardRef as ReactComponent };